var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.groupName)?_c('v-chip',{attrs:{"outlined":"","color":"blue-grey","text-color":"white"}},[_vm._v("\n        "+_vm._s(_vm.groupName)+"\n    ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }